import {isMobile} from "react-device-detect";
import MobileMyOrders from "./MobileMyOrders";
import DesktopMyOrders from "./DesktopMyOrders";

export default isMobile ? MobileMyOrders : DesktopMyOrders